
import './colllection.scss'

import React, { useState, useEffect } from "react";
import { Link, NavLink, useHistory } from "react-router-dom";
// import CreateDiscountModal from "./CreateDiscountModal";
import Environment from "utils/environment";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Spinner from "react-bootstrap/Spinner";
import moment from "moment";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";

const Collection = () => {
    const val = localStorage.getItem("accessToken");
    const api_url = Environment.base_url;
    const history = useHistory();
    const [loader, setLoader] = useState(false);
    const [csvData, setCSVData] = useState([]);

    const [deleteId, setDeleteId] = useState("");
    const [opType, setOpType] = useState("");
    const [editId, setEditId] = useState("");
    const [pageCount, setPageCount] = useState([]);
    const [offset, setOffset] = useState(1);
    const [page, setPage] = useState(1);
    const [count, setCount] = useState(0);
    const [limit, setLimit] = useState(10);
    const url = api_url + "/discounts/csv/";

    const [searchQuery, setSearchQuery] = useState("");
    const [publishedFilter, setPublishedFilter] = useState(false);
    const [unpublishedFilter, setUnpublishedFilter] = useState(false);
    const [getCollectionsave, setgetCollectionsave] = useState([]);

    const [assignshow, setassignShow] = useState(false);
    const [assignshow1, setassignShow1] = useState(false);
    const [assignshow2, setassignShow2] = useState(false);

    const handlePublishedFilter = (e) => {
        if (e.target.checked) {
            setPublishedFilter(true);
            setUnpublishedFilter(false);
        } else if (!e.target.checked) {
            setPublishedFilter(false);
        }
    };

    const handleUnpublishedFilter = (e) => {
        if (e.target.checked) {
            setUnpublishedFilter(true);
            setPublishedFilter(false);
        } else if (!e.target.checked) {
            setUnpublishedFilter(false);
        }
    };

    const getDiscountCSV = async () => {
        // validateUserName();
        // if (!errors) {
        setLoader(true);
        setCSVData([]);
        const config = {
            method: "get",
            url:
                api_url +
                "/discounts/csv?limit=" +
                limit +
                "&offset=" +
                offset +
                "&search=fileName=" +
                searchQuery +
                "&" +
                `${!publishedFilter && !unpublishedFilter
                    ? ""
                    : publishedFilter || unpublishedFilter
                        ? "filter=isPublish=eq:" + publishedFilter
                        : ""
                }`,
            headers: {
                Authorization: "Bearer " + val,
            },
        };

        await axios(config)
            .then((res) => {
                const resData = res?.data?.data;
                setCSVData(resData?.files);
                let arr = Array.from(Array(parseInt(resData.pages)).keys());
                setCount(resData?.count);
                setPage(resData?.pages);
                setPageCount(arr);
                setLoader(false);
            })
            .catch((err) => {
                if (err?.response?.status == 501) {
                    localStorage.removeItem("accessToken");
                    history.push("/");
                } else if (err?.response?.status == 401) {
                    localStorage.removeItem("accessToken");
                    history.push("/");
                    // FetchRefreshToken();
                    console.log("refresh token: ", err?.response);
                }
                console.log("error meessage: ", err?.response?.data?.message);
                toast.error(err?.response?.data?.message, {
                    position: "top-right",
                    autoClose: 2000,
                });
                setLoader(false);
            });
        // }
    };


    useEffect(() => {
        if (!val) {
            history.push("/");
        } else {
            getDiscountCSV();
        }
    }, [offset, publishedFilter, unpublishedFilter, searchQuery]);




    /// API'S
    const getCollection = async () => {
        try {
            const response = await axios.get(`${api_url}/store/products/admin-products?limit=${limit}&offset=${offset}&`, {
                headers: {
                    Authorization: "Bearer " + val,
                },
            })
             setgetCollectionsave(response.data.data.Collection)

        } catch (error) {
            console.error("Error fetching products:", error);

        }

    }



    const Collectionpatch = async (id) => {
        try {

            const response = await axios.patch(
                `${api_url}/discounts/csv/${id}/is-publish`,
                {
                    headers: {
                        Authorization: "Bearer " + val,
                    },
                }
            );
            if (response?.data?.data?.Collection) {
                getCollection()

            }

        } catch (err) {
            if (err?.response?.status == 501) {
                history.push("/");
            } else {
                console.log("error meessage: ", err?.response?.data?.message);
                toast.error(err?.response?.data?.message, {
                    
                    position: "top-right",
                    autoClose: 2000,
                });
            }
            setLoader(false);
        }


        // setLoader(true);
        // const config = {
        //     method: "patch",
        //     url: api_url + "/discounts/csv/" + id + "/is-publish",
        //     headers: {
        //         Authorization: "Bearer " + val,
        //     },
        // };

        // await axios(config)
        //     .then((res) => {
        //         // setLoader(false);
        //         getDiscountCSV();
        //     })
        //     .catch((err) => {
        //         if (err?.response?.status == 501) {
        //             history.push("/");
        //         } else {
        //             console.log("error meessage: ", err?.response?.data?.message);
        //             toast.error(err?.response?.data?.message, {
        //                 position: "top-right",
        //                 autoClose: 2000,
        //             });
        //         }
        //         setLoader(false);
        //     });
    };


    useEffect(() => {
        getCollection()
    }, []);



      const newcollections = async (id) => {
        try {
            const response = await axios.delete(`${api_url}/newdel/${id}/collections` , {
                headers:{
                 Authorization: "Bearer " + val,

                }
            }) ;
              
        } catch (error) {
            
        }
      }

    return (
        <>
            <section className="maincollection">
                <div className="headermain">
                    <h4 className="headertag">
                        Collection
                    </h4>

                    <Link
                        to={{
                            pathname: "/admin/createcolllection",

                        }}
                        className="tble_details"
                    >

                        <button className='btncollection'>
                            <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M7.5 7H2C1.448 7 1 7.448 1 8C1 8.552 1.448 9 2 9H7.5V14.5C7.5 15.052 7.948 15.5 8.5 15.5C9.052 15.5 9.5 15.052 9.5 14.5V9H15C15.552 9 16 8.552 16 8C16 7.448 15.552 7 15 7H9.5V1.5C9.5 0.948 9.052 0.5 8.5 0.5C7.948 0.5 7.5 0.948 7.5 1.5V7Z" fill="white" />
                            </svg>
                            Create Collection
                        </button>
                    </Link>
                </div>
                <div className="table-customer">
                    <div className="table-customer">
                        <table class="table">
                            <thead>
                                <tr>
                                    <th scope="col">On/Off</th>
                                    <th scope="col">Collection Name</th>
                                    <th scope="col">Total Products</th>
                                    <th scope="col">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {csvData?.length > 0 ? (
                                    csvData?.map((item, index) => {
                                        return (
                                            <>
                                                <tr>


                                                    <td>
                                                        {/* <div className="switch-input">
                                                            <input
                                                                class="tgl tgl-ios"
                                                                type="checkbox"
                                                                id={(index + offset).toString()}
                                                            />
                                                            <label
                                                                for={(index + offset).toString()}
                                                                class="tgl-btn"
                                                            ></label>
                                                        </div> */}
                                                        <div className="switch-input">
                                                            <input
                                                                class="tgl tgl-ios"
                                                                type="checkbox"
                                                                id={(index + offset).toString()}
                                                                defaultChecked={item?.isPublish}
                                                                onChange={() =>
                                                                    Collectionpatch(item?.id)
                                                                }
                                                            />
                                                            <label
                                                                for={(index + offset).toString()}
                                                                class="tgl-btn"
                                                            ></label>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="detailbutton">

                                                            <p>K&Ns</p>

                                                            {/* <span className="red-span">
                                                                    K&Ns
                                                                </span> */}

                                                        </div>
                                                    </td>
                                                    <td>
                                                        <p>Nov 25, 2021</p>
                                                    </td>
                                                    <td>
                                                        <div className="images">
                                                            <img className='cursor-pointer' src="\assestsss\edit-2.png" alt="" />
                                                            <img
                                                                src="\assestsss\trash.svg"
                                                                className="img-fluid"
                                                                alt=""
                                                                onClick={() => {
                                                                    setassignShow2(true);
                                                                    setDeleteId(item?.id);
                                                                }}
                                                            />
                                                        </div>
                                                    </td>
                                                </tr>
                                            </>
                                        );
                                    })
                                ) : loader ? (
                                    <tr>
                                        <td colSpan="8" className="text-center">
                                            <div className="text-center">
                                                {<Spinner animation="border" variant="info" />}
                                                {/* <h4>No Categories</h4> */}
                                            </div>
                                        </td>
                                    </tr>
                                ) : (
                                    <p>No Records</p>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="mainfoot">
                    <div className="left">
                        {count > 0 && count <= limit ? (
                            <>
                                <p>
                                    SHOWING 1-{count} OF {count}
                                </p>
                            </>
                        ) : count > limit ? (
                            <>
                                <p>
                                    SHOWING{" "}
                                    {offset > 1 ? (offset - 1) * limit + 1 : offset} -
                                    {limit * offset > count ? count : limit * offset} OF{" "}
                                    {count}
                                </p>
                            </>
                        ) : (
                            <>
                                <p>SHOWING 0 OF 0</p>
                            </>
                        )}
                    </div>
                    <div className="right">
                        <nav aria-label="Page navigation example">
                            <ul class="pagination">
                                <Stack spacing={2}>
                                    <Pagination
                                        count={page}
                                        page={offset}
                                        onChange={(e, p) => setOffset(p)}
                                        color="primary"
                                    />
                                </Stack>
                            </ul>
                        </nav>
                    </div>
                </div>
            </section>

        </>
    )
}

export default Collection